﻿var openPositionsPagination = {
    props: ['itemsPerPage', 'maxPageNumeration', 'totalItems', 'currentPage'],
    data: function () {
        return {
        }
    },
    computed: {
        totalPages: function () {
            if (this.itemsPerPage === 0) {
                return 0;
            }

            return Math.ceil(this.totalItems / this.itemsPerPage);
        },
        isOnFirstPage: function () {
            return this.currentPage != 1;
        },
        isOnLastPage: function () {
            return this.currentPage != this.totalPages;
        },
        lowerBound: function () {
            var bound = Math.min((this.totalPages + 1) - this.maxPageNumeration, this.currentPage - Math.floor(this.maxPageNumeration / 2));
            return Math.max(1, bound);
        },
        upperBound: function () {
            return Math.min(this.totalPages + 1, this.lowerBound + this.maxPageNumeration);
        },
        paginationRange: function() {
            var start = this.lowerBound;
            var stop = this.upperBound;
            return new Array(stop - start).fill(start).map((n, i) => n + i);
        },
        hasMultiplePages: function() {
            return this.totalPages != 1;
        }
    },
    methods: {
        showPage: function (pageIndex) {
            this.$emit('show', pageIndex);
        },
        turnPage: function (delta) {
            var targetIndex = this.currentPage + delta;

            if (targetIndex >= 1 && targetIndex <= this.totalPages) {
                this.showPage(targetIndex);
            }
        }
    }
}

var sortingButton = {
    template: '#sorting-button-template',
    props: ['sortProp', 'title', 'sortion'],
    data: function () {
        return {
            desc: true
        }
    },
    computed: {
        active: function() {
            return this.sortion == this.sortProp;
        }
    },
    methods: {
        sort: function () {
            this.desc = !this.desc;
            this.$emit('sort', this.sortProp, this.desc);
        }
    }
}

export const Init = function(Vue) {
    if (document.getElementById('open-positions') == null) {
        return 'undefined';
    }
    return new Vue({
        el: '#open-positions',
        mounted: function () {
            this.displayCount = parseInt(this.$el.getAttribute('data-display-count'));
            this.$data.filters.country = !this.$el.getAttribute('data-country') ? '' : this.$el.getAttribute('data-country');

            this.getPositions();
        },
        data: {
            displayCount: 0,
            filteredItemsCount: 0,
            currentPage: -1,
            positions: [],
            filtered: [],
            displayed: [],
            loading: true,
            sortedBy: '',
            filters: {
                search: '',
                position: '',
                country: '',
                city: '',
                publishDate: ''
            },
            sorting: '',
            positionOptions: [],
            countryOptions: [],
            cityOptions: [],
            dateOptions: [],
            IsTimeout: false
        },
        computed: {
            filterSearch: {
                get() {
                    return this.$data.filters.search;
                },
                set(value) {
                    this.$data.filters.search = value;
                    this.showPage(1);
                }
            },
            filterPosition: {
                get() {
                    return this.$data.filters.position;
                },
                set(value) {
                    this.$data.filters.position = value;
                    this.showPage(1);
                }
            },
            filterCountry: {
                get() {
                    return this.$data.filters.country;
                },
                set(value) {
                    this.$data.filters.country = value;
                    this.showPage(1);
                }
            },
            filterCity: {
                get() {
                    return this.$data.filters.city;
                },
                set(value) {
                    this.$data.filters.city = value;
                    this.showPage(1);
                }
            },
            filterPublishDate: {
                get() {
                    return this.$data.filters.publishDate;
                },
                set(value) {
                    this.$data.filters.publishDate = value;
                    this.showPage(1);
                }
            },
            filteredItems: function () {
                const _self = this;

                var searchTerm = this.$data.filters.search.toLowerCase();
                
                var dateTerm = new Date();
                dateTerm.setDate(dateTerm.getDate() - this.$data.filters.publishDate);

                var items = this.$data.positions.filter(function(x) {
                    var searched = searchTerm === '' || x.Title.toLowerCase().indexOf(searchTerm) !== -1;
                    var cityMatched = _self.$data.filters.city === '' || x.PrimaryLocation.City == _self.$data.filters.city;
                    var countryMatched = _self.$data.filters.country === '' || x.PrimaryLocation.Country.Name == _self.$data.filters.country;
                    var publishDateBound = _self.$data.filters.publishDate === '' || x.StartDate.Date > dateTerm;

                    return searched && cityMatched && countryMatched && publishDateBound;
                });

                this.$data.filteredItemsCount = items.length;

                return items;
            }
        },
        components: {
            'pagination': openPositionsPagination,
            'sorting-button': sortingButton
        },
        methods: {
            getPositions: function() {
                const _self = this;

                var url = "/teliadk/OpenPositionsBlock/GetPositions";
                TL.xhrJSON(url, function (oData) {
                    if (oData.success) {
                        oData.data.Positions = _self.parseDates(oData.data.Positions);

                        _self.$data.positions = oData.data.Positions;
                        _self.$data.filteredItemsCount = _self.$data.positions.length;
                        _self.$data.loading = false;

                        _self.$data.positionOptions = _self.getUniques(oData.data.Positions, 'PositionType.Name');
                        _self.$data.countryOptions = _self.getUniques(oData.data.Positions, 'PrimaryLocation.Country.Name');
                        _self.$data.cityOptions = _self.getUniques(oData.data.Positions, 'PrimaryLocation.City');

                        _self.$data.positionTypes = oData.types;
                        _self.$data.IsTimeout = false;
                        _self.showPage(1);
                    } else if (oData.data.IsTimeout){
                        _self.$data.positions = [];
                        _self.$data.filteredItemsCount = 0;
                        _self.$data.loading = false;
                        _self.$data.positionOptions = [];
                        _self.$data.countryOptions = [];
                        _self.$data.cityOptions = [];
                        _self.$data.IsTimeout = true;
                        _self.showPage(1);
                    } else { 
                    }
                });
            },
            sortBy: function (prop, desc) {
                const _self = this;
                _self.sortedBy = prop;
                _self.sorting = desc ? -1 : 1;

                _self.showPage(1);
            },
            getUniques: function(data, prop) {
                prop = prop.split('.');
                var len = prop.length;

                return data.map(function(x){
                    var i = 0;
                    while (i < len){x = x[prop[i]]; i++;}
                    return x;
                }).filter(function(val, idx, arr){
                    return arr.indexOf(val) === idx && (val != '' || val != 'undefined');
                });
            },
            applyFilters: function() {
                const _self = this;

                var searchTerm = this.$data.filters.search.toLowerCase();
                
                var dateTerm = new Date();
                dateTerm.setDate(dateTerm.getDate() - this.$data.filters.publishDate);

                var items = this.$data.positions.filter(function(x) {
                    var searched = searchTerm === '' || x.Title.toLowerCase().indexOf(searchTerm) !== -1;
                    var cityMatched = _self.$data.filters.city === '' || x.PrimaryLocation.City == _self.$data.filters.city;
                    var countryMatched = _self.$data.filters.country === '' || x.PrimaryLocation.Country.Name == _self.$data.filters.country;
                    var publishDateBound = _self.$data.filters.publishDate === '' || x.StartDate.Date > dateTerm;

                    return searched && cityMatched && countryMatched && publishDateBound;
                });

                this.$data.filteredItemsCount = items.length;
                this.$data.filtered = items;
            },
            getDateObject: function (data) {
                if (data === null || data === 'undefined') {
                    return {
                        Original: date,
                        Date: null,
                        Display: ''
                    }
                }

                var date = new Date(parseInt(data.replace("/Date(", "").replace(")/", ""), 10));

                var day = date.getDate();
                day = (day <= 9 ? '0' : '') + day;

                var month = (date.getMonth() + 1);
                month = (month <= 9 ? '0' : '') + month;

                var dateObject = {
                    Original: data,
                    Date: date,
                    Display: date.getFullYear() + '-' + month + '-' + day
                };

                return dateObject;
            },
            parseDates: function (data) {
                const _self = this;

                return data.map(function (x) {
                    x.ApplicationDeadLine = _self.getDateObject(x.ApplicationDeadLine);
                    x.StartDate = _self.getDateObject(x.StartDate);
                    return x;
                });
            },
            showPage: function (pageIndex) {
                this.$data.currentPage = pageIndex;

                const _self = this;

                var searchTerm = this.$data.filters.search.toLowerCase().trim();
                
                var dateTerm = new Date();
                dateTerm.setDate(dateTerm.getDate() - this.$data.filters.publishDate);

                var prop = this.$data.sortedBy.split('.');
                var len = prop.length;

                var filtered = this.$data.positions.filter(function(x) {
                    var searchedTitle = searchTerm === '' || x.Title.toLowerCase().indexOf(searchTerm) !== -1;
                    var searchPosition = searchTerm === '' || x.PositionType.Name.toLowerCase().indexOf(searchTerm) !== -1;
                    var searchCity = searchTerm === '' || x.PrimaryLocation.City.toLowerCase().indexOf(searchTerm) !== -1;
                    var SearchCountry = searchTerm === '' || x.PrimaryLocation.Country.Name.toLowerCase().indexOf(searchTerm) !== -1;
                    var position = _self.$data.filters.position === '' || x.PositionType.Name == _self.$data.filters.position;
                    var cityMatched = _self.$data.filters.city === '' || x.PrimaryLocation.City == _self.$data.filters.city;
                    var countryMatched = _self.$data.filters.country === '' || x.PrimaryLocation.Country.Name == _self.$data.filters.country;
                    var publishDateBound = _self.$data.filters.publishDate === '' || x.StartDate.Date > dateTerm;
                    var searched = (searchedTitle || searchPosition || searchCity || SearchCountry);
                    return searched && position && cityMatched && countryMatched && publishDateBound;
                }).sort(function (a, b) {
                    var i = 0;
                    while (i < len) { a = a[prop[i]]; b = b[prop[i]]; i++; }

                    if(a === null){
                        return 1;
                    }
                    else if(b === null){
                        return -1;
                    }

                    if (a < b) return -1 * _self.sorting;
                    if (a > b) return 1 * _self.sorting;
                    return 0;
                });

                this.$data.filtered = filtered;
                this.$data.filteredItemsCount = filtered.length;

                var start = (this.$data.currentPage - 1) * this.$data.displayCount;
                var end = Math.min(start + this.$data.displayCount, this.filtered.length);
                
                this.$data.displayed = this.filtered.slice(start, end);
            },
            openUrl: function(url){
                var win = window.open(url, '_blank');
                win.focus();
            }
        }
    });
}
